// src/components/DemoBanner.jsx
// Sticky banner shown to demo account users across all pages
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Eye, X, ArrowRight } from 'lucide-react';

export default function DemoBanner() {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className="bg-amber-500 text-white px-4 py-2.5 flex items-center justify-between gap-4 flex-shrink-0 z-40">
      <div className="flex items-center gap-2.5 min-w-0">
        <Eye className="h-4 w-4 flex-shrink-0" />
        <p className="text-sm font-medium truncate">
          You're viewing a <span className="font-bold">demo account</span> — data is for illustration only. Actions are disabled.
        </p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <Link
          to="/register"
          className="flex items-center gap-1.5 bg-white text-amber-600 text-xs font-semibold px-3 py-1.5 rounded-lg hover:bg-amber-50 transition-colors whitespace-nowrap"
        >
          Start free trial <ArrowRight className="h-3.5 w-3.5" />
        </Link>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 rounded hover:bg-amber-600 transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
